<script>
  import { modalReservation, User } from "../../store";
  import fetchNodeProduction from "../../helpers/FetchNodeProduction.js";
  export let message;
  export let error;
  
  let loading = false;
  let reservation;
  let dateFrom;
  let dateTo;
  let sellRate;


  modalReservation.subscribe((value) => {
    reservation = value;
    dateFrom = reservation.dateFrom?.slice(0,10);
    dateTo = reservation.dateTo?.slice(0,10);
    sellRate = reservation.sellRate;
  });

  function parseMessage(data) {
    const { message } = data;
    if (message == "token expired") { 
      User.logout();
    }
    if (message.part1) {
      return `${message.part1 || ""} ${message.part2 || ""} ${
        message.part3 || ""
      } ${message.part4 || ""}`;
    }
    return message;
  }

  async function submitForm() {
    try {
      error = "";
      message = "";
      loading = true;
      const formData = new FormData();
      formData.append("dateFrom", dateFrom);
      formData.append("dateTo", dateTo);
      formData.append("reservationId", reservation.id);
      formData.append("sellRate", sellRate);
      let response = await fetchNodeProduction(
        "/extendReservation",
        formData
      );
      if (typeof response === "object") {
        if (response.status == true) {
          message = parseMessage(response.data);
        } else {
          error = parseMessage(response);
        }
      }
      loading = false;
    } catch (ex) {
      console.log(ex);
    } finally {
      loading = false;
    }
  }
</script>


<form on:submit|preventDefault={submitForm}>
  <div class='form-control-row'>
    <label for="dateFrom"> Check-In</label>
    <input name="dateFrom" type="date" bind:value={dateFrom}>
  </div>
  <div class='form-control-row'>
    <label for="dateTo"> Check-out</label>
    <input name="dateTo" type="date" bind:value={dateTo}>
  </div>

  <div class='form-control-row'>
    <label for="sellRate"> Sell rate</label>
    <input name="sellRate" bind:value={sellRate} />
  </div>

  <button type="submit" class="pink-button" disabled={loading} >  
      {loading ? "Loading..." : "Extend Reservation"}
  </button>
</form>
{#if error}
  <small>
    <strong>
      <p class="red-font">
        {error}
      </p>
    </strong>
  </small>
{/if}
{#if message}
  <small>
    <strong>
      <p class="blue-font">
        {message}
      </p>
    </strong>
  </small>
{/if}
<style>
  .pink-button {
    background-color: #ed4368;
    color: #fff;
    margin-top: 10px;
    width: 100%;
  }
  .red-font {
    color: rgb(194, 32, 32);
  }
  .row {
    display:flex;
    flex:1;
    flex-direction: row;
  }
  label{
    margin: 10px auto;
  }
  .date-picker-btn{
    border: 1px;
  }
  .form-control {
    display:flex;
    flex:1;
    flex-direction: column;
    padding-top: 15px;

  }
  input{
    width: 100%;
  }
</style>
